// ** React Imports
import { Fragment, useEffect, useState } from 'react'
// ** Table Data & Columns
import { columns } from './components/data'
import '@styles/react/libs/tables/react-dataTable-component.scss'
// ** Third Party Components
import ReactPaginate from 'react-paginate'
import DataTable from 'react-data-table-component'
import { ChevronDown } from 'react-feather'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

// ** Reactstrap Imports
import { Card } from 'reactstrap'
import './style.scss'
import { useParams } from 'react-router-dom'
import InvoicesFilter from './components/filter'
import { useDispatch, useSelector } from 'react-redux'
import {
  getCountries,
  getTaxpayerTypes,
  getPersonTypes,
  getDepartments,
  getDocumentTypes,
  getEconomicActivities,
  getMeasurementUnit,
  getPaymentMethod,
  getSaleTypes,
} from '../invoice-issuance/thunks'
import { getClients } from './thunks'

const MySwal = withReactContent(Swal)

const Invoices = ({ transactions = [] }) => {
  // ** States
  const { data, filteredData } = useSelector(
    (state) => state.customerMaster
  )
  const params = useParams()
  const [currentPage, setCurrentPage] = useState(0)
  const [searchValue, setSearchValue] = useState('')
  const [filteredDataState, setFilteredData] = useState(data)
  const [totalRecords, setTotalRecords] = useState(data.length || 0)

  useEffect(() => {
    setTotalRecords(data.length)
  }, [data])

  const [modal, setModal] = useState(false)

  const [filterData, setFilterData] = useState({
    pageNumber: 1,
    pageSize: 25,
    status: +params.statusDocument,
  })

  const onFilter = (filterProp) => {
    setFilterData({ ...filterData, ...filterProp })
  }

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getDepartments())
    dispatch(getEconomicActivities())
    dispatch(getDocumentTypes())
    dispatch(getMeasurementUnit())
    dispatch(getSaleTypes())
    dispatch(getPaymentMethod())
    dispatch(getClients())
    dispatch(getCountries())
    dispatch(getTaxpayerTypes())
    dispatch(getPersonTypes())
  }, [dispatch])

  const toggleModal = (show, document) => {
    setModal(show)
    if (show && document) {
      getDocumentTracking(document)
    }
  }

  useEffect(() => {
    setTotalRecords(data.length)
    // Filtrado de datos basado en el valor de búsqueda
    // console.log("searchValue: ", searchValue)

    if (searchValue.length > 0) {
      const filtered = data.filter((item) =>
        item.nit.includes(searchValue)
      )
      setFilteredData(filtered)
    } else {
      setFilteredData(data)
    }
  }, [data, searchValue])
  // ** Function to handle Pagination
  const handlePagination = (page) => {
    setCurrentPage(page.selected)
  }

  // ** Pagination Previous Component
  const Previous = () => {
    return (
      <Fragment>
        <span className="align-middle d-none d-md-inline-block">
          Anterior
        </span>
      </Fragment>
    )
  }

  // ** Pagination Next Component
  const Next = () => {
    return (
      <Fragment>
        <span className="align-middle d-none d-md-inline-block">
          Siguiente
        </span>
      </Fragment>
    )
  }

  const CustomPagination = () => (
    <ReactPaginate
      previousLabel={<Previous />}
      nextLabel={<Next />}
      forcePage={currentPage}
      onPageChange={(page) => handlePagination(page)}
      pageCount={Math.ceil(totalRecords / 25)}
      breakLabel={'...'}
      pageRangeDisplayed={2}
      marginPagesDisplayed={2}
      activeClassName={'active'}
      pageClassName={'page-item'}
      nextLinkClassName={'page-link'}
      nextClassName={'page-item next'}
      previousClassName={'page-item prev'}
      previousLinkClassName={'page-link'}
      pageLinkClassName={'page-link'}
      breakClassName="page-item"
      breakLinkClassName="page-link"
      containerClassName={
        'pagination react-paginate pagination-sm justify-content-end pe-1 mt-1'
      }
    />
  )

  return (
    <Fragment>
      <InvoicesFilter onFilter={onFilter} />
      <Card>
        <div className={`react-dataTable master-view-batch-table`}>
          {data.length > 0 && (
            <DataTable
              noHeader
              pagination
              columns={columns(toggleModal)}
              paginationPerPage={25}
              className="react-dataTable"
              responsive={true}
              sortIcon={<ChevronDown size={10} />}
              paginationComponent={CustomPagination}
              paginationDefaultPage={currentPage + 1}
              data={filteredData}
            />
          )}
        </div>
      </Card>
    </Fragment>
  )
}

export default Invoices
